export default __webpack_public_path__ + "static/media/640_business08-jp-web.8a595cc7.png";